import MemberValidationContainer from './MemberValidationContainer'

export default MemberValidationContainer;